import { render, staticRenderFns } from "./UserWalletTransactions.vue?vue&type=template&id=06650f46&"
import script from "./UserWalletTransactions.vue?vue&type=script&lang=js&"
export * from "./UserWalletTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports